
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flow from 'vux/src/components/flow/flow.vue'
import FlowState from 'vux/src/components/flow/flow-state.vue'
import FlowLine from 'vux/src/components/flow/flow-line.vue'


import {Uploader} from 'vant';
import 'vant/lib/uploader/style'

export default {
name: "step2",
components: {
Group,
XButton,
Flow,
FlowState,
FlowLine,
Uploader
},
data(){
return{
lockButton:false
}
},
methods: {
doPayment(config) {
/*微信支付*/
let self = this;

function onBridgeReady() {
WeixinJSBridge.invoke(
'getBrandWCPayRequest', config,
function (res) {
let _self = this;
if (res.err_msg == "get_brand_wcpay_request:ok") {
self.$vux.loading.hide();

self.$vux.alert.show({
title: '恭喜，充入成功',
content: '保证金缴费成功',
onHide() {
_self.$router.push('/uc/seller-request?step=3')
}
})
} else {
self.$vux.loading.hide();
let errSuffix = '';
if (res.err_desc !== undefined) {
errSuffix = '，(错误:' + res.err_desc + ')';
}

self.$vux.alert.show({
title: '微信支付未完成',
content: '微信支付未完成，请稍后重新尝试支付.' + errSuffix,
});

self.lockButton = false;
}
}
);
}

if (typeof WeixinJSBridge == "undefined") {
if (document.addEventListener) {
document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
} else if (document.attachEvent) {
document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
}
} else {
onBridgeReady();
}
},
recharge() {
let _self = this;
this.$vux.confirm.show({
title: '操作确认',
content: '您要立即缴纳保证金？',
confirmText: '继续',
onConfirm() {
_self.lockButton = true;
_self.$vux.loading.show();
const url = _self.tianYiWebUrl + '/wechat/uc/paySellerRequest';
_self.$http.post(url, {uid: _self.uid, number: _self.number}).then(res => {
_self.$vux.loading.hide();
if (res.data.code === 200) {

_self.doPayment(res.data.data);
} else {
_self.$vux.alert.show({
title: '出错了',
content: '系统开小差了'
});
_self.lockButton = false;
}
})
}
});
},
next() {
this.recharge();
}
}
}



// WEBPACK FOOTER //
// ./src/components/sellerRequest/step2.vue